import React, { useContext, useEffect, useState } from 'react'
import { ContextType } from '../../type/type'
import { AppContext } from '../../App'
import { Title } from '../../style/style'
import { Text } from './style/WrapperTextPageStyle'
import { Empty, Spin } from 'antd'
import { getRequest } from '../../request/request'
import { errors } from '../../function/errors'
import { useTranslation } from 'react-i18next'
import { parseUrl } from '../../function/parseUrl'
import ModalPreviewDocument from '../ModalPreviewDocument/ModalPreviewDocument'
import { log } from 'util'
import { ReactComponent as ClipIcon } from './../../static/icon/clip.svg'


interface TextProps {
  id: number | string
  disabledFile?: boolean | null
  top?: boolean | null
}

const WrapperTextPage: React.FC<TextProps> = ({ id, disabledFile, top }) => {
  const { state } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [visible, setVisible] = useState<boolean>(false)
  const [hrefDocument, setHrefDocument] = useState(null)

  useEffect(() => {
    setData(null)
    getRequest(`/pages/page/${id}/`)
      .then((res) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(res?.data?.text || '', 'text/html')
  
        // Обворачивание динамических таблиц в div для навешивания скролла
        doc.querySelectorAll('table').forEach((table) => {
          const wrapper = doc.createElement('div')
          wrapper.className = 'table-overflow-wrapper'
          table.parentNode?.insertBefore(wrapper, table)
          wrapper.appendChild(table)
        })
  
        setData({ ...res.data, text: doc.body.innerHTML })
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        errors(err)
      })
  }, [state.lang, id])


//   setData(null)
//   getRequest(`/pages/page/${id}/`)
//     .then((res) => {
//       const parser = new DOMParser()
//       const doc = parser.parseFromString(res?.data?.text || '', 'text/html')

//       doc.querySelectorAll('table').forEach((table) => {
//         const wrapper = doc.createElement('div')
//         wrapper.className = 'table-new'
//         table.parentNode?.insertBefore(wrapper, table)
//         wrapper.appendChild(table)
//       })

//       setData({ ...res.data, text: doc.body.innerHTML })
//       setLoading(false)
//     })
//     .catch((err) => {
//       setLoading(false)
//       errors(err)
//     })
// }, [state.lang, id])

  useEffect(() => {
    const elDocument = document.body.querySelectorAll('.fadeIn a')
    const key = Object.keys(elDocument)

    key.map((e: any) => {
      elDocument[e].addEventListener('click', (event: any) => {
        const target = event.target.closest('a')
        const href = target?.href
        const parse = parseUrl('?', 'file', href)

        if (parse) {
          event.preventDefault()
          setHrefDocument(href)
          setVisible(true)
        }
      })
    })
  }, [data])

  const handleLInk = (file: []) =>
    file.map(({ id, name, file_path }) => ( 
      <li key={id} style={{display: 'flex', gap: '5px'}}>
        <ClipIcon style={{width: '40px'}}></ClipIcon>
        <a download target="_blank" rel="noopener noreferrer" href={file_path} style={{width: '100%'}}>
          {name}
        </a>
      </li>
    ))

  return (
    <>
      {loading && <Spin spinning={true} />}

      {data ? (
        <>
          {visible && <ModalPreviewDocument myUrl={hrefDocument} visible={visible} setVisible={setVisible} />}

          <div className="fadeIn box-text" style={{ wordWrap: 'normal' }}>
            <Title className="title">{data?.title}</Title>
            {top &&
            !disabledFile &&
            Object.prototype.hasOwnProperty.call(data, 'duplicate_links') &&
            data?.duplicate_links &&
            data?.page_files?.length ? (
              <>
                <h3 className="title">{t('h44')}:</h3>
                <ol className="default-padding-list">{handleLInk(data?.page_files)}</ol>
                <hr />
                <br />
              </>
            ) : null}

            <Text dangerouslySetInnerHTML={{ __html: data?.text }} className='fadeIn-text'/>

            {!top &&
            !disabledFile &&
            Object.prototype.hasOwnProperty.call(data, 'duplicate_links') &&
            data?.duplicate_links &&
            data?.page_files.length ? (
              <>
                <hr />
                <h3 className="title">{t('h44')}:</h3>
                <ul className="default-padding-list">{handleLInk(data.page_files)}</ul>
              </>
            ) : null}
          </div>
        </>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </>
  )
}

export default WrapperTextPage
